import { render, staticRenderFns } from "./KeyWordsHint.vue?vue&type=template&id=37b31d3e&scoped=true"
import script from "./KeyWordsHint.vue?vue&type=script&lang=js"
export * from "./KeyWordsHint.vue?vue&type=script&lang=js"
import style0 from "./KeyWordsHint.vue?vue&type=style&index=0&id=37b31d3e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b31d3e",
  null
  
)

export default component.exports